export default {
  title: {
    id: 'guest_orders_resend_link_title',
    defaultMessage: 'This link has expired',
  },
  content: {
    id: 'guest_orders_resend_link_content',
    defaultMessage:
      'Select the button below and we\u2019ll send a new link to your email.',
  },
  cta: {
    id: 'guest_orders_resend_link_cta',
    defaultMessage: 'Send new link',
  },
}
